import React from "react";
import { Grid as MuiGrid } from "@mui/material";

import type { IContract } from "@framework/types";
import { StyledAvatar } from "@framework/styled";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Typography } from "@dzambalaorg/ui-kit";

interface IContractContentProps {
  contract: IContract;
}

export const ContractContent = ({ contract }: IContractContentProps) => {
  return (
    <MuiGrid container size={12} mt={1} mb={5}>
      <MuiGrid size={3}>
        <StyledAvatar src={contract.imageUrl} />
      </MuiGrid>
      <MuiGrid size={9}>
        <Typography variant="body2" color="textSecondary" component="div">
          <RichTextDisplay data={contract.description} />
        </Typography>
      </MuiGrid>
    </MuiGrid>
  );
};
